<!-- assignment-documents.component.html -->
<div class="documents-container">
  @if (!isLoading()) {
    <div>
      <div class="document-list">
        @for (doc of documents(); track doc) {
          <div class="document-item" [class.selected]="doc === selectedDocument()">
            <span class="document-item-title">{{ doc.FileName }}</span>
            <div class="document-item-buttons">
              <dx-button
                class="preview"
                (click)="previewDocument(doc, $event)"
                [text]="'DOCU.DTO.PREVIEW' | translate"></dx-button>
              <dx-button
                class="download"
                (click)="downloadDocument(doc, $event)"
                [text]="'DOCU.DTO.DOWNLOAD' | translate"></dx-button>
            </div>
          </div>
        }
      </div>
    </div>
  } @else {
    <app-loader></app-loader>
  }
</div>

<!-- Preview Popup -->
<dx-popup
  [visible]="selectedDocument() !== null"
  [showCloseButton]="true"
  [showTitle]="true"
  [title]="'DOCU.DTO.PREVIEW_TITLE' | translate"
  (onHiding)="closePreview()"
  [width]="'90%'"
  [height]="'90%'"
  [dragEnabled]="true"
  [hideOnOutsideClick]="false"
  [container]="document.body"
  [position]="{ of: windowRef, my: 'center', at: 'center' }"
  [shading]="false">
  @if (selectedDocument()) {
    <div class="preview-container">
      <!-- Conditional Rendering Based on File Type -->
      @switch (getFileExtension(selectedDocument()?.FileName)) {
        @case ('pdf') {
          <iframe [src]="currentBlobUrl ? (currentBlobUrl | safe) : ''"></iframe>
        }
        @case ('jpg') {}
        @case ('jpeg') {}
        @case ('png') {}
        @case ('gif') {}
        @case ('bmp') {
          <img [src]="currentBlobUrl ? (currentBlobUrl | safe) : ''" alt="Preview Image" />
        }
        @case ('msg') {
          <p>{{ 'DOCU.DTO.PREVIEW_ERROR' | translate }}</p>
        }
        @default {
          <p>{{ 'DOCU.DTO.PREVIEW_ERROR' | translate }}</p>
        }
      }
    </div>
  }
</dx-popup>

<!-- Loading Template -->
